import { render, staticRenderFns } from "./CCPaymentDetail.vue?vue&type=template&id=05372fab"
import script from "./CCPaymentDetail.vue?vue&type=script&lang=js"
export * from "./CCPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports